import createIcon from '../../createIcon';

/**
 * @component @name Fivrg
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcgMTNIMTlWMTVIMTRWOUgyMUMyMSA3LjkgMjAuMSA3IDE5IDdIMTRDMTIuOSA3IDEyIDcuOSAxMiA5VjE1QzEyIDE2LjEgMTIuOSAxNyAxNCAxN0gxOUMyMC4xIDE3IDIxIDE2LjEgMjEgMTVWMTFIMTdWMTNaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMyAxM0g4VjE1SDNWMTdIOEM5LjEgMTcgMTAgMTYuMSAxMCAxNVYxM0MxMCAxMS45IDkuMSAxMSA4IDExSDVWOUgxMFY3SDNWMTNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Fivrg = createIcon('Fivrg', [
  [
    'path',
    {
      d: 'M17 13H19V15H14V9H21C21 7.9 20.1 7 19 7H14C12.9 7 12 7.9 12 9V15C12 16.1 12.9 17 14 17H19C20.1 17 21 16.1 21 15V11H17V13Z',
      key: '1enb5o',
    },
  ],
  [
    'path',
    {
      d: 'M3 13H8V15H3V17H8C9.1 17 10 16.1 10 15V13C10 11.9 9.1 11 8 11H5V9H10V7H3V13Z',
      key: '12znwg',
    },
  ],
]);

export default Fivrg;
